import { requirePermission } from "@lib/permissions/guards";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { ArrowLeftRight } from "lucide-react";

export const Route = createFileRoute("/_app/stock/mouvements")({
  staticData: {
    title: "Mouvements",
    icon: ArrowLeftRight,
    tab_icon: ArrowLeftRight,
    permission: "stock.movements.view",
    module: "stock",
    section: "Stock",
    order: 48,
    showInTab: true,
    showInNav: true,
    showInBreadcrumb: true,
  },
  loader: requirePermission("stock.movements.view"),
  component: () => <Outlet />,
});
